<template>
  <CourseList
    level-key="upperIntermediateLevel"
    fetch-action="getCourseUpperIntermediates"
    getter-name="courseUpperIntermediates"
  />
</template>

<script>
import CourseList from "@/components/CourseList.vue";

export default {
  name: "UpperIntermediateCourse",
  components: { CourseList },
};
</script>
